<template>
  <div id="maxBox">
    <el-carousel :interval="5000" arrow="always" height="947px">
      <el-carousel-item>
        <div :class="homeType">
          <div class="content" v-if="isMobile">
            <img
              class="bg"
              :src="require('../images/mobile_X5/X5.png')"
              alt=""
            />
            <div class="info">
              <div class="title">X5</div>
              <div class="introduction">
                微仓X5系列是一款具备了超大品类容量，超强品牌价值，超能智能载体多种优势功能为一体的优质智能终端设备。
              </div>

              <div class="smallTitle">
                8大系统实现中国少有的智能售货技术突破
              </div>
              <div class="label">
                <div class="point"></div>
                10秒拿取
              </div>
              <div class="label">
                <div class="point"></div>
                100%空间利用
              </div>
              <div class="label">
                <div class="point"></div>
                990种不同产品
              </div>
              <button @click="buyX5" class="buy">订购我的X5</button>
              <button @click="seeX5" class="see">了解 X5</button>
            </div>
          </div>
          <div
            v-if="!isMobile"
            :style="
              'background-image:url(' +
                require('../images/home/home1.png') +
                ')'
            "
            class="content"
          >
            <div class="info">
              <div class="title">X5</div>
              <div class="introduction">
                微仓X5系列是一款具备了超大品类容量，超强品牌价值，
                超能智能载体多种优势功能为一体的优质智能终端设备。
              </div>
              <div class="introduction1">
                8大系统实现中国少有的智能售货机技术突破<br />
                <img
                  class="point"
                  :src="require('../images/home/point.png')"
                  alt=""
                />
                10秒拿取<br />
                <img
                  class="point"
                  :src="require('../images/home/point.png')"
                  alt=""
                />
                100%空间利用<br />
                <img
                  class="point"
                  :src="require('../images/home/point.png')"
                  alt=""
                />
                990种不同产品
              </div>
              <button @click="buyX5" class="buy">订购我的X5</button>
              <button @click="seeX5" class="see">了解 X5</button>
            </div>
          </div>
          <PageBottom v-if="isMobile"></PageBottom>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div style="width: 100%; height: 100%">
          <div class="aimg">
            <button
              style="padding:16px 100px;background-color:#FC9900;position: absolute;top:62%;left:9.5%;color:#fff"
              @click="gotoPage"
            >
              免费体验
            </button>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="introduce">
      <div class="sizeMax">
        标准化的业务流程，为您搭建专属的工业物料管理体系
      </div>
      <div style="font-size: 18px; margin-top: 20px">
        <div>
          当您使用微仓(NVM)工业物料智能存取系统时，是您在整个公司实施物料的精益库存管理最全面有效的解决方案。
        </div>
        <div>有了标准化的流程和可视化的数据信息，您就可以：</div>
        <div>更好地服务和赢的客户的订单，了解您公司业务的真实工作流程；</div>
        <div>根据实际数据追溯有缺陷的批次物品和库存需求预测；</div>
        <div>您随时知道他们拿了什么东西，什么时候拿的，拿了多少；</div>
        <div>通过一个完整的库存控制系统，您随时都知道您的整个库存在哪里。</div>
      </div>
    </div>
    <div class="banner">
      <div class="bannerTitle">
        <div class="title">什么是微仓X5</div>
        <div style="margin-top: 20px; font-size: 18px">
          X5是奕优经历多年打造推出的一款智能物料存取机器。它可适配摆放多种场地，放置1000种不同商品。让库存量最低，节省资金。
        </div>
        <div style="font-size: 18px">
          兼容全品类，不管是紧固件刀具等工业品，还是手机数码、潮玩、珠宝、名酒等。实现智能化无人值守。
        </div>
      </div>
      <div class="mainA">
        <div style="width: 48%">
          <img src="../images/home/banner1.png" style="width: 100%" />
        </div>
        <div class="dv-trans-o0">
          <div class="names">线上线下智慧互联</div>
          <div style="margin-top: 20px">
            一台设备一套系统，实现物料的智能化管理。强大的物料智能管理终端设备，确保了可靠性、可控
            性和准确性。同时，微仓智能存取系统降低了库存成本，提高了工作人员的生产效率。微仓的创新
            MRO智能存取系统可以在很短的周期内带来很高的投入产出比。
          </div>
        </div>
      </div>
      <div class="mainA">
        <div class="dv-trans-o1">
          <div class="names">微仓系统版本丰富性价比高</div>
          <div style="margin-top: 20px">
            针对不同企业规模、行业和业态，奕优微仓提供各种系统版本满足您的需求；基础版、标准版、定制版。
          </div>
        </div>
        <div style="width: 48%">
          <img src="../images/home/banner2.png" style="width: 100%" />
        </div>
      </div>
      <div class="mainA">
        <div style="width: 48%">
          <img
            src="../images/home/banner3.png"
            style="width: 100%; height: 100%"
          />
        </div>
        <div class="dv-trans-o2">
          <div class="names">完整的供应链</div>
          <div style="margin-top: 20px">
            利用微仓X5，达到对物料的储存、配送全环节质量信息实行动态管理和控制。以降低仓储及运输成本、通过整合、优化仓储及配送服务，与合作伙伴强强联合。
          </div>
        </div>
      </div>
      <div class="mainA">
        <div class="dv-trans-o3">
          <div class="names">智能解决方案</div>
          <div style="margin-top: 20px">
            基于单元化管理18年研发、生产、服务经验，通过对物料动态管理过程的不断持续优化，提供了新三化（单元智慧化、单元自动化、单元智能化）解决方案，从而提升三大环节（周转、存取、配送）物料管理的效能，并赋能产品，实现无人化管理。
          </div>
        </div>
        <div style="width: 48%">
          <img
            src="../images/home/banner4.png"
            style="width: 100%; height: 100%"
          />
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="advantageA">微仓X5的优势</div>
      <div class="bgcList">
        <div class="advantageAs">
          <div class="advantageAsd">AI智能</div>
          <div class="advantageAsdf">
            <div><span>· 智能终端展示</span></div>
            <div><span>· 智能取货方式</span></div>
            <div><span>· 智能AI交互方式</span></div>
            <div><span>· 智能管理系统</span></div>
          </div>
        </div>
        <div class="advantageAs2">
          <div class="advantageAsd">强大后台</div>
          <div class="advantageAsdf">
            <div><span>· 远程管理</span></div>
            <div><span>· 预警通知</span></div>
            <div><span>· 数据分析</span></div>
            <div><span>· 多平台查看</span></div>
          </div>
        </div>
        <div class="advantageAs3">
          <div class="advantageAsd">更全品类</div>
          <div class="advantageAsdf">
            <div><span>· 工业用品</span></div>
            <div><span>· 潮流玩具</span></div>
            <div><span>· 文旅用品</span></div>
            <div><span>· 3C电子产品等更多品类</span></div>
          </div>
        </div>
        <div class="advantageAs4">
          <div class="advantageAsd">大数据统计</div>
          <div class="advantageAsdf">
            <div><span>· 工业用品</span></div>
            <div><span>· 实时交易管理</span></div>
            <div><span>· 实时数据统计</span></div>
            <div><span>· 实时监控</span></div>
          </div>
        </div>
      </div>
      <div class="freeBtn" @click="gotoPage">免费体验</div>
    </div>
    <div class="bottom">
      <div class="xinxi">专利荣誉</div>
      <div style="margin-top: 33px; width: 100%; height: 100%">
        <img src="../images/home/jiang.png" />
      </div>
    </div>
    <div class="bottomTips">
      <span
        @click="goOtherWeb(item)"
        v-for="item in bottomTips"
        :key="item.label"
        class="item"
        >{{ item.label }}</span
      >
    </div>
  </div>
</template>

<script>
import store from "../store/index";
import PageBottom from "../components/pageBottom";
export default {
  name: "Home",
  data() {
    return {
      bottomTips: [
        { label: "IEOU©2023", path: "" },
        {
          label: "沪ICP备19026522号-3",
          path: "https://beian.miit.gov.cn/#/Integrated/index"
        },
        { label: "隐私和法律", path: "" },
        { label: "联系我们", path: "" },
        { label: "最新消息", path: "" }
      ],
      scrollDom: []
    };
  },
  watch: {
    scroll(value) {
      console.log(value, "cccAAA");
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.isMobile) {
        this.$store.commit("edit_backgroundColor", "rgba(0, 0, 0, .3)");
      }
    }, 0);
    this.listenerFunction();
  },
  methods: {
    listenerFunction(e) {
      document.addEventListener("scroll", this.handleScroll, true);
      this.$nextTick(() => {
        this.scrollDom = document.querySelectorAll(".mainA");
      });
    },
    handleScroll(value) {
      let offsetY = window.pageYOffset;
      this.scrollDom.forEach((v, i) => {
        console.log(offsetY, v.offsetTop - v.clientHeight, value, "cccccAAA");
        if (offsetY > v.offsetTop - v.clientHeight - 200) {
          document.querySelector(`.dv-trans-o${i}`).style.transform =
            "translate(0px,0px)";
          document.querySelector(`.dv-trans-o${i}`).style.animation = "fade-in";
          // document.querySelector(`.dv-trans-o${i}`).style.animationDuration='5s'
          document.querySelector(`.dv-trans-o${i}`).style.transition =
            "transform 2s";
        }
      });
      // if(offsetY >= 1200){
      //   let mainA = document.querySelectorAll('.dv-trans-o')
      //   mainA[0].style.transform='translate(0px,0px)'
      //   mainA[0].style.animation='fade-in'
      //   mainA[0].style.animationDuration='1s'
      // }
    },
    // gotoPage() {
    //   this.$router.push({
    //     path: "/login",
    //     query: {
    //       free: true
    //     }
    //   });
    // },
    gotoPage() {
      let userName = sessionStorage.getItem("user");
      if (userName) {
        console.log(JSON.parse(userName));
        let { mobilePhone, accessToken, mobilePassword } = JSON.parse(userName);
        window.open(
          `${process.env.VUE_APP_PROJECT_URL}?token=${accessToken}&account=${mobilePhone}&password=${mobilePassword}`
        );
      } else {
        this.$router.push({
          path: "/login",
          query: {
            free: true
          }
        });
      }
    },

    goOtherWeb(item) {
      if (item.path) {
        window.open(item.path);
      }
    },
    seeX5() {
      this.$router.push("/X5Details");
    },
    buyX5() {
      this.$router.push("/buy");
    }
  },
  // FreeExperienceBtn(){
  // },
  components: {
    PageBottom
  },
  computed: {
    homeType() {
      if (store.state.screenWidth <= 800) {
        return "mobile_home";
      } else {
        return "home";
      }
    },
    isMobile() {
      return store.state.isMobile;
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../less/home.less");
#maxBox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.home {
  height: 100%;
  width: 100%;
  .point {
    width: 4px;
    height: 4px;
    display: inline-block;
    vertical-align: middle;
    transform: translate(0, -1px);
  }
  .content {
    position: relative;
    height: 100%;
    background: 80% no-repeat;
    background-size: cover;
    .info {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      left: 24%;
      width: 400px;
      .title {
        font-size: 1.851852rem /* 50/27 */;
        color: rgba(255, 255, 255, 0.85);
        line-height: 2.592593rem /* 70/27 */;
      }
      .introduction {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.85);
        margin-bottom: 16px;
      }
      .introduction1 {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.85);
        margin-bottom: 32px;
      }
      .buy {
        width: 200px;
        height: 40px;
        background: #000000;
        border-radius: 2px;
        opacity: 0.86;
        text-align: center;
        line-height: 40px;
        color: #ffffff;
        margin-bottom: 16px;
        cursor: pointer;
        display: block;
      }
      .see {
        width: 200px;
        height: 40px;
        background: #ffffff;
        border-radius: 2px;
        opacity: 0.86;
        text-align: center;
        line-height: 40px;
        color: #000000;
        margin-bottom: 16px;
        cursor: pointer;
      }
    }
    @media (max-width: 1200px) {
      .info {
        left: 14%;
      }
    }
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.introduce {
  background: #f2f2f2;
  text-align: center;
  padding: 70px 0;
}
.sizeMax {
  font-size: 44px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}
.banner {
  background: #ffffff;
  padding: 70px 232px;
}
.bannerTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 80px 0;
}
.title {
  font-size: 38px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}
.mainA {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0 0 0;
  width: 100%;
}
.names {
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}
.advantage {
  width: 100%;
  box-sizing: border-box;
  padding: 70px 226px;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 576px;
}
.bgcList {
  display: flex;
  justify-content: space-between;
}
.advantageA {
  font-size: 38px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
}
.advantageAs {
  background-image: url(../images/home/4.png);
  background-size: 100%;
  height: 263px;
  padding: 24px;
  width: 25%;
}
.advantageAs2 {
  background-image: url(../images/home/1.png);
  background-size: 100%;
  height: 263px;
  padding: 24px;
  width: 25%;
}
.advantageAs3 {
  background-image: url(../images/home/2.png);
  background-size: 100%;
  height: 263px;
  padding: 24px;
  width: 25%;
}
.advantageAs4 {
  background-image: url(../images/home/3.png);
  background-size: 100%;
  height: 263px;
  padding: 24px;
  width: 25%;
}
.advantageAsd {
  font-size: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.advantageAsdf {
  padding: 16px 24px;
  width: 301px;
  height: 138px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  margin: 24px 0 0 0;
}
.freeBtn {
  width: 320px;
  height: 48px;
  background: #fc9900;
  border-radius: 2px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom {
  padding: 70px 134px;
  background: #ffffff;
  text-align: center;
}
.xinxi {
  font-size: 38px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: 9px;
}
.bottomTips {
  height: 52px;
  margin: -40px 0 0 0;
  text-align: center;
  .item {
    padding: 0 1.6%;
    color: #000000;
    cursor: pointer;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  } /*初始状态 透明度为0*/
  40% {
    opacity: 0;
  } /*过渡状态 透明度为0*/
  100% {
    opacity: 1;
  } /*结束状态 透明度为1*/
}
@-webkit-keyframes fade-in {
  /*针对webkit内核*/
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.dv-trans-o0 {
  width: 48%;
  transform: translate(200px, 0px);

  transition: transform 0.35s;
  //  animation: fade-in;
  // animation-duration: 8s;
  // -webkit-animation:fade-in 1.5s;
}
.dv-trans-o1 {
  width: 48%;
  transform: translate(-200px, 0px);

  transition: transform 0.35s;
  //  animation: fade-in;
  // animation-duration: 8s;
  // -webkit-animation:fade-in 1.5s;
}
.dv-trans-o2 {
  width: 48%;
  transform: translate(200px, 0px);

  transition: transform 0.35s;
  //  animation: fade-in;
  // animation-duration: 8s;
  // -webkit-animation:fade-in 1.5s;
}
.dv-trans-o3 {
  width: 48%;
  transform: translate(-200px, 0px);

  transition: transform 0.35s;
  //  animation: fade-in;
  // animation-duration: 8s;
  // -webkit-animation:fade-in 1.5s;
}
.aimg {
  position: relative;
  height: 100%;
  width: 100%;
  background-image: url(../images/home/Group.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
